import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  margin: 1.5rem;
`

export default class Pad extends Component {
  render() {
    const style = this.props.style || {}
    style.breakInside = style.breakInside || 'avoid'
    return <Box {...this.props} style={style} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/Pad.js